import { Address } from '../address.model';

const allowedMarkets = ['TR'];

export function addDistrictToAddress(address: Address, district: string, countryCode: string): Address {
    if (allowedMarkets.includes(countryCode) && district) {
        return {
            ...address,
            colony: district,
        };
    }
    return address;
}
